(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/banner-grid-item/views/header-subtitle.js') >= 0) return;  svs.modules.push('/components/lb-ui/banner-grid-item/views/header-subtitle.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.lb_ui=_svs.lb_ui||{};
_svs.lb_ui.banner_grid_item=_svs.lb_ui.banner_grid_item||{};
_svs.lb_ui.banner_grid_item.templates=_svs.lb_ui.banner_grid_item.templates||{};
svs.lb_ui.banner_grid_item.templates.header_subtitle = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"banner-grid-item-header-subtitle\">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":1,"column":46},"end":{"line":1,"column":54}}}) : helper)))
    + "</div>\n";
},"useData":true});
Handlebars.partials['components-lb_ui-banner_grid_item-header_subtitle'] = svs.lb_ui.banner_grid_item.templates.header_subtitle;
})(svs, Handlebars);


 })(window);